import styled from "styled-components";

/* 
    Styled Provider 
*/

const primary = (props) => props.theme.palette.primary;
const secondary = (props) => props.theme.palette.secondary;
const lightgreen = (props) => props.theme.palette.lightgreen;

const roboto = (props) => props.theme.fonts.roboto;
const opensans = (props) => props.theme.fonts.opensans;

export const StyledProvider = styled.div`
  width: 100%;
  padding: 0;
  margin: 0;
  box-sizing: border-box;

  body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
      "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
      "Helvetica Neue", sans-serif;
    background-color: #f5f5f9;
  }

  /* 
    Sweet Alert Modal 
  */
  .swal2-container {
    z-index: 2001 !important;
  }

  /* 
    Scroll Modal  
  */
  .MuiDialogContent-root::-webkit-scrollbar {
    width: 10px;
  }
  .MuiDialogContent-root::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
  }
  .MuiDialogContent-root::-webkit-scrollbar-thumb {
    background: #0c2d6a;
    border-radius: 5px;
    border: 1px solid #f1f1f1;
  }
  .MuiDialogContent-root::-webkit-scrollbar-thumb:hover {
    background: #0f52ba;
  }

  /*Botoes */
  Button {
    span:not(.material-icons) {
      margin: 2.5px;
      font-family: ${opensans}, sans-serif;
      font-weight: bold !important;
    }
    .MuiIcon-root:not(.material-icons) {
      font-family: "Material Icons" !important;
      font-size: 14px !important;
    }
  }

  /* Tabelas */
  Table {
    Thead {
      background-color: ${secondary};
      box-shadow: 3px 3px 3px ${(props) => props.theme.palette.darkgrey};
      tr {
        .Mui-checked {
          color: ${primary};
        }
        th {
          span {
            font-size: 90% !important;
            font-family: ${opensans}, sans-serif !important;
          }
        }
      }
    }
    Tbody {
      td {
        font-family: ${roboto};
        .Mui-checked {
          color: ${primary};
        }
        /* Title Chip */
        .MuiChip-root {
          span {
            font-size: 80% !important;
          }
        }
      }
      .Mui-selected {
        background-color: ${lightgreen};
        &:hover {
          background-color: ${lightgreen};
        }
        border: none;
      }
    }
  }

  /* Input Text Field */
  .MuiFormControl-root {
    width: 100%;

    label {
      font-family: ${opensans} !important;
      font-size: 90% !important;
    }

    input {
      font-family: ${roboto} !important;
      font-size: 90% !important;
    }
  }

  /* Label Switch */
  .MuiFormControlLabel-root {
    .MuiTypography-body1 {
      font-family: ${opensans} !important;
      font-size: 85% !important;
    }
  }

  /* Title Chip */
  .MuiChip-root {
    span {
      font-size: 110% !important;
      font-weight: normal !important;
      font-family: ${opensans} !important;
    }
  }

  /* Pulse Animation */
  .pulse {
    animation: pulse 1s infinite;
  }
  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.7);
    }
    70% {
      box-shadow: 0 0 0 10px rgba(0, 123, 255, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(0, 123, 255, 0);
    }
  }
`;
